var SDK_VERSION = '7.0.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
